//식단표 이미지 4장 그리기 — 목업 meal-plan-download.html 캔버스 코드를 수치 그대로 옮김 (식단표 만들기 도구와 동일한 레이아웃)
//전역 D() 대신 WeekView 를 인자로 받는 것만 다름. 휴무 문구는 요일별 배열(holText[kind][요일])
import { DAYS, WEEK_COLORS, WeekView } from "./mealplanutil";
import { FOOD_SRC, LOGO_SRC, PLATE_SRC } from "./mealplanassets";

const INK = "#333D4B";
const FONT = 'Pretendard,-apple-system,"Apple SD Gothic Neo","Malgun Gothic",sans-serif';

const imgCache: { [src: string]: Promise<HTMLImageElement> } = {};
const loadImg = (src: string) => {
    if (!imgCache[src]) {
        imgCache[src] = new Promise((res, rej) => {
            const i = new Image();
            i.onload = () => res(i);
            i.onerror = (e) => { delete imgCache[src]; rej(e); };
            i.src = src;
        });
    }
    return imgCache[src];
};

//썸네일 음식 선택창 미리 불러오기용
export const preloadFood = () => { Object.values(FOOD_SRC).forEach((src) => loadImg(src).catch(() => { })); };

function rr(x: CanvasRenderingContext2D, X: number, Y: number, W: number, H: number, r: number) {
    x.beginPath(); x.moveTo(X + r, Y); x.arcTo(X + W, Y, X + W, Y + H, r); x.arcTo(X + W, Y + H, X, Y + H, r); x.arcTo(X, Y + H, X, Y, r); x.arcTo(X, Y, X + W, Y, r); x.closePath();
}
function fit(x: CanvasRenderingContext2D, t: string, cx: number, y: number, maxW: number, size: number, weight: number, color: string) {
    let s = size;
    for (; ;) { x.font = `${weight} ${s}px ${FONT}`; if (x.measureText(t).width <= maxW || s <= 15) break; s--; }
    x.fillStyle = color; x.textAlign = "center"; x.fillText(t, cx, y);
}
function canvas(w: number, h: number) { const c = document.createElement("canvas"); c.width = w; c.height = h; return c; }

const col = (d: WeekView) => WEEK_COLORS[d.week] || WEEK_COLORS[1];
const title = (d: WeekView) => `${d.month}월 ${d.week}주차`;
const curScale = (d: WeekView) => (d.scale || 100) / 100;

//썸네일 음식 — 저장값 없으면 호출부에서 자동 추천 이름을 넣어 줌
async function foodImg(name: string) { return loadImg(FOOD_SRC[name] || FOOD_SRC["볶음밥"]); }

async function drawFood(d: WeekView, food: string, x: CanvasRenderingContext2D, px: number, py: number, pw: number, fs: number) {
    const [plate, img] = await Promise.all([loadImg(PLATE_SRC), foodImg(food)]);
    const ph = pw * plate.height / plate.width; x.drawImage(plate, px, py, pw, ph);
    const cx = px + pw * 0.497, cy = py + ph * 0.474;
    fs = fs * curScale(d); x.save(); x.shadowColor = "rgba(60,40,20,.18)"; x.shadowBlur = 16; x.shadowOffsetY = 6; x.drawImage(img, cx - fs / 2, cy - fs / 2, fs, fs); x.restore();
}

export async function drawThumb(d: WeekView, food: string) {
    const W = 1080, c = canvas(W, W), x = c.getContext("2d")!;
    x.fillStyle = col(d); x.fillRect(0, 0, W, W); x.textAlign = "left"; x.fillStyle = INK;
    x.font = `700 82px ${FONT}`; x.fillText(title(d), 65, 182); x.font = `500 82px ${FONT}`; x.fillText("정기/특식 식단", 65, 284);
    const logo = await loadImg(LOGO_SRC); x.drawImage(logo, W - 65 - 285, 121, 285, 40);
    await drawFood(d, food, x, 234, 326, 735, 300); return c;
}

const HDR = { P: 56, titleY: 118, subY: 190, logoY: 84, logoW: 226, logoH: 32 };
async function drawHeader(d: WeekView, x: CanvasRenderingContext2D, W: number, sub: string) {
    x.textAlign = "left"; x.fillStyle = INK; x.font = `700 58px ${FONT}`; x.fillText(title(d), HDR.P, HDR.titleY); x.font = `500 52px ${FONT}`; x.fillText(sub, HDR.P, HDR.subY);
    const logo = await loadImg(LOGO_SRC); x.drawImage(logo, W - HDR.P - HDR.logoW, HDR.logoY, HDR.logoW, HDR.logoH);
}

export async function drawBanner(d: WeekView, food: string) {
    const W = 1080, H = 752, c = canvas(W, H), x = c.getContext("2d")!;
    rr(x, 0, 0, W, H, 40); x.fillStyle = col(d); x.fill();
    await drawHeader(d, x, W, "정기/특식 식단"); await drawFood(d, food, x, 457, 262, 576, 235); return c;
}

function sun(x: CanvasRenderingContext2D, cx: number, cy: number) {
    x.save(); x.fillStyle = "#FFB31F"; x.strokeStyle = "#FFB31F"; x.lineWidth = 3; x.lineCap = "round"; x.beginPath(); x.arc(cx, cy, 8, 0, Math.PI * 2); x.fill();
    for (let i = 0; i < 8; i++) { const a = i * Math.PI / 4; x.beginPath(); x.moveTo(cx + Math.cos(a) * 12, cy + Math.sin(a) * 12); x.lineTo(cx + Math.cos(a) * 16, cy + Math.sin(a) * 16); x.stroke(); } x.restore();
}
function moon(x: CanvasRenderingContext2D, cx: number, cy: number, bg: string) {
    x.save(); x.fillStyle = "#FFD43B"; x.beginPath(); x.arc(cx, cy, 12, 0, Math.PI * 2); x.fill(); x.fillStyle = bg; x.beginPath(); x.arc(cx + 6, cy - 5, 10, 0, Math.PI * 2); x.fill(); x.restore();
}

export async function drawBody(d: WeekView, kind: "reg" | "sp") {
    const W = 1080, P = 56, TOP = 262, HEAD = 72, ROW = 48, SEC = kind === "reg" ? 7 * ROW + 24 : 140, BLOCK = HEAD + 2 * SEC, GAP = 24, H = TOP + 2 * BLOCK + GAP + P;
    const c = canvas(W, H), x = c.getContext("2d")!;
    rr(x, 0, 0, W, H, 40); x.fillStyle = col(d); x.fill();
    await drawHeader(d, x, W, kind === "reg" ? "정기식 식단표" : "특식 식단");
    const LW = 84, CW = (W - 2 * P - LW) / 3, DARK = "#6B7684", LINE = "#EBEEF2";
    for (let b = 0; b < 2; b++) {
        const y0 = TOP + b * (BLOCK + GAP), ds = b ? [3, 4, 5] : [0, 1, 2];
        x.save(); rr(x, P, y0, W - 2 * P, BLOCK, 24); x.fillStyle = "#FFFFFF"; x.fill(); x.clip();
        x.fillStyle = DARK; x.fillRect(P, y0 + HEAD + SEC, LW, SEC);
        x.fillStyle = LINE; x.fillRect(P, y0 + HEAD - 1, W - 2 * P, 2); x.fillRect(P + LW, y0 + HEAD + SEC - 1, W - 2 * P - LW, 2);
        for (let i = 0; i < 3; i++) x.fillRect(P + LW + i * CW - 1, y0, 2, BLOCK);
        x.restore();
        const lx = P + LW / 2;
        sun(x, lx, y0 + HEAD + SEC / 2 - 20); x.textAlign = "center"; x.fillStyle = INK; x.font = `700 26px ${FONT}`; x.fillText("중식", lx, y0 + HEAD + SEC / 2 + 28);
        moon(x, lx, y0 + HEAD + SEC + SEC / 2 - 20, DARK); x.fillStyle = "#FFFFFF"; x.fillText("석식", lx, y0 + HEAD + SEC + SEC / 2 + 28);
        ds.forEach((dd, i) => {
            const cx0 = P + LW + i * CW, cxm = cx0 + CW / 2, hol = d.hol[kind][dd];
            x.textAlign = "center"; x.font = `700 32px ${FONT}`; x.fillStyle = hol ? "#F04452" : (dd === 5 ? "#3182F6" : INK); x.fillText(DAYS[dd], cxm, y0 + 48);
            (["lunch", "dinner"] as const).forEach((m, mi) => {
                const sy = y0 + HEAD + mi * SEC;
                if (hol) { fit(x, d.holText[kind][dd], cxm, sy + SEC / 2 + 9, CW - 28, 24, 500, "#4E5968"); return; }
                if (kind === "reg") {
                    const items = d.reg![m][dd] || [];
                    for (let r = 0; r < 7; r++) { const ry = sy + 12 + r * ROW; if (r % 2 === 1) { rr(x, cx0 + 10, ry + 4, CW - 20, ROW - 8, 10); x.fillStyle = "#F2F4F6"; x.fill(); } if (items[r]) fit(x, items[r], cxm, ry + 32, CW - 36, 24, 500, INK); }
                } else {
                    const e = d.sp![m][dd] || { store: "", menu: "" };
                    if (e.store) fit(x, e.store, cxm, sy + 50, CW - 28, 25, 700, INK);
                    rr(x, cx0 + 14, sy + 70, CW - 28, 46, 12); x.fillStyle = "#F2F4F6"; x.fill();
                    if (e.menu) fit(x, e.menu, cxm, sy + 101, CW - 48, 22, 500, "#4E5968");
                }
            });
        });
    }
    return c;
}

export const blobOf = (cv: HTMLCanvasElement) => new Promise<Blob | null>((r) => cv.toBlob(r, "image/png"));
